angular.module('charts')
  .directive('listTable', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        columns: '=',
        rowData: '=',
        disableInfiniteScroll: '@',
        noDataMessage: '@',
        aggregationsEnabled: '@',
        aggregationData: '='
      },
      templateUrl: '/resources/charts/partials/list-table.html',
      controller: 'ListTableController'
    };
  });

angular.module('charts').controller('ListTableController', ['$scope', '$filter', 'tableSort', '$rootScope', 'authentication', function($scope, $filter, $tableSort, $rootScope, authentication) {

  $scope.page = 1;
  $scope.loadingPage = false;
  $scope.tableSortService = $tableSort;
  $scope.aggregationsEnabled = false;

  var filterRow = function(row) {
    _.forEach($scope.columns, function(column) {
      if(column.filter) {
        row[column.id] = $filter(column.filter)(row[column.id]);
      }
    });
    return row;
  };

  $scope.handleRowClick = function(row) {
    $scope.$emit('listTableRowClicked', row);
  };

  $scope.getColorByStatus = function(columnId, row) {
    if (row[columnId + '_status'] === 2) {
      var customerIsAdmin = authentication.getCustomer().isAdmin;
      if (customerIsAdmin !== null && customerIsAdmin) {
        // https://dreambox.atlassian.net/browse/IN-4563 --> do not return red in list table views for admins
        return '';
      } else {
        return 'text-warn';
      }
    } else if (row[columnId + '_status'] === 1) {
      return 'text-congratulate';
    }
    return '';
  };

  var onEarlierYearSelectionChange = function(e) {
    $scope.disableRowSelection = $rootScope.isEarlierYearSelected;
  };
  onEarlierYearSelectionChange();
  $rootScope.$on('earlierYearSelectionChange', onEarlierYearSelectionChange);

  var handlePaging = function() {

    if(!$scope.loadingPage && !$scope.disableInfiniteScroll) {
      $scope.page++;
      $scope.loadingPage = true;
      $scope.$emit('listTableNextPage', $scope.page);
    }
  };

  $scope.filterRows = function() {
    if (!$scope.columns || !$scope.rowData || $scope.rowData.length === 0) {
      return;
    }
    $scope.localRows = angular.copy($scope.rowData);
    $scope.localRows = _.map($scope.localRows, function(row) {
      return filterRow(row);
    });
  };

  $scope.generateOrderIndicator = function(sortType, order) {
    if(sortType === 'text') {
      if(order === 'asc') {
        return 'A-Z';
      }
      else {
        return 'Z-A';
      }
    }

    if(sortType === 'numeric') {
      if(order === 'asc') {
        return 'Low-High';
      }
      else {
        return 'High-Low';
      }
    }
  };

  $scope.generateSortOptions = function(columns) {
    var result = [];
    if(!_.isArray(columns) || columns.length === 0) {
      return result;
    }

    _.forEach(columns, function(column) {
      var ascOption = _.pick(column, ['id', 'name', 'sortType']);
      ascOption.order = 'asc';
      ascOption.orderIndicator = $scope.generateOrderIndicator(column.sortType, 'asc');
      var descOption = _.pick(column, ['id', 'name', 'sortType']);
      descOption.order = 'desc';
      descOption.orderIndicator = $scope.generateOrderIndicator(column.sortType, 'desc');
      result.push(ascOption);
      result.push(descOption);
    });

    return result;
  };

  $scope.$on('rightPaneScrollBottom', handlePaging);

  $scope.$on('mobileScrollBottom', handlePaging);
  $scope.$watchGroup(['columns', 'rowData'], function() {
    $scope.loadingPage = false;
    $scope.sortOptions = $scope.generateSortOptions($scope.columns);
    $scope.selectedSortOption = _.findWhere($scope.sortOptions, {id: $tableSort.activeColumnId});
    $scope.filterRows();
  });
}]);
